export const getFormattedTime = date => {
  const currentDate = new Date();
  const postDate = new Date(date);

  const dateDiff = currentDate - postDate;
  const daysAgo = Math.floor(dateDiff / 1000 / 60 / 60 / 24);

  if (daysAgo > 6) {
    return postDate.toDateString().slice(4);
  }

  if (daysAgo >= 1) {
    return `${daysAgo} ${daysAgo === 1 ? 'day' : 'days'} ago`;
  }

  const hoursAgo = Math.floor(dateDiff / 1000 / 60 / 60);
  const minsAgo = Math.floor((dateDiff / 1000 / 60) - (hoursAgo * 60))

  if (hoursAgo > 0) {
    return `${hoursAgo} h${minsAgo > 0 ? ` ${minsAgo} mins` : ''} ago`;
  }

  if (minsAgo > 0) {
    return `${minsAgo} ${minsAgo === 1 ? 'min' : 'mins'} ago`;
  }

  return 'just now';
};

export const sliceText = (text, maxSymbols) => text.length > maxSymbols ? `${text.slice(0, maxSymbols - 1)}…` : text;

export const getVideoId = videoUrl => videoUrl.replace('https://www.youtube.com/watch?v=', '')

export const getImageUrl = ({ post_id, video_url, small }) => {
  if (video_url) {
    return `https://img.youtube.com/vi/${getVideoId(video_url)}/0.jpg`
  }

  return `https://d6njcdhhgy0m4.cloudfront.net/${post_id}/${small ? 'small' : 'regular'}`
};
